import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from "react"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import { useNavigate } from "react-router-dom"
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import Radio from '@mui/material/Radio';
import TermModal from "../Modals/Refund-terms-modal"



const RefundForm = ({ id }) => {

  dayjs.extend(timezone)
  dayjs.extend(utc)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [acceptTerms, setAcceptTerms] = useState(false)
  const [additionalDate, setAdditionalDate] = useState(dayjs())
  const [validity, setValidity] = useState(dayjs().add(7, 'day'))
  const [selectedFlightType, setSelectedFlightType] = useState('')
  const termModal = useRef()
  const openModal = () => termModal.current.openModal()
  const handleChangeFlightType = (event) => {
    setSelectedFlightType(event.target.value);
  }

  const handleAcceptTerms = (e) => {
    console.log(e, 'this is e')
    if (e.target.checked === true) {
      setAcceptTerms(true)
    } else {
      setAcceptTerms(false)
    }
  }





  const [inputFields, handleChange, setInputFields] = useForm({
    iban: {
      name: 'iban',
      type: 'text',
      value: '',
      placeholder: '860 ......'
    },
    amount: {
      name: 'amount',
      type: 'text',
      value: '',
      decimal: true,
      placeholder: '1,000'
    },
    primaryContact: {
      name: 'primaryContact',
      type: 'text',
      value: '',
      placeholder: 'محمد محمدی'
    },
    phone: {
      name: 'phone',
      type: 'text',
      value: '',
      placeholder: '912*******'
    },
    email: {
      name: 'email',
      type: 'text',
      value: '',
      placeholder: 'me@example.com'
    },
    pnr: {
      name: 'pnr',
      type: 'text',
      value: '',
      placeholder: 'CNJJUT'
    },
    service: {
      name: 'service',
      type: 'select',
      value: '',
      items: [],
      selected: null,
    },
    paymentGateway: {
      name: 'pgw',
      value: '',
      type: 'select',
      selected: null,
      items: []
    },
    comment: {
      name: 'comment',
      value: '',
      type: 'textarea',
      placeholder: 'Write comment...'
    }
  })

  const getProductsAndAccounts = async () => {

    const res = await ajax({
      method: 'GET',
      url: utils.urls.accessibleProduct,
      snackbar: enqueueSnackbar,
      hasToken: true
    })

    if (!res) return

    const serviceItems = res.data.map(service => {
      return {
        label: service.name,
        id: service.id,
        data: service
      }
    })

    const response = await ajax({
      method: 'GET',
      url: utils.urls.visiblePaymentGateway,
      snackbar: enqueueSnackbar,
      hasToken: true
    })

    if (!response) return
    const IpgAccounts = response.data.filter((account => account.type === 'IBAN'))
    const accounts = IpgAccounts.map(acc => {
      return {
        label: acc.name,
        id: acc.id,
        data: acc
      }
    })
    setInputFields({
      ...inputFields,
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: accounts[0].id,
        items: accounts,
        value: accounts[0].label
      },
      service: {
        ...inputFields.service,
        items: serviceItems,
        selected: serviceItems[0].id,
        value: serviceItems[0].label
      }
    })


  }


  const getOffice = JSON.parse(window.localStorage.getItem('userInfo'))

  const handleSelectDropDown = (service) => {
    console.log(service, ' console service')
    setInputFields({
      ...inputFields,
      service: {
        ...inputFields.service,
        selected: service.id,
        value: service.name
      }
    })
  }

  const handlePGWDropDown = (pgw) => {
    console.log(pgw, ' console pgw')
    setInputFields({
      ...inputFields,
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: pgw.id,
        value: pgw.name
      }
    })
  }

  const handleDatepicker = (e) => {
    setAdditionalDate(e)
  }

  const createTransaction = async () => {

    // console.log(inputFields.service, 'services')
    // console.log(inputFields.paymentGateway, 'pgws')
    // console.log(validity.tz("Asia/Tehran").toISOString(), 'pgws')
    // console.log(validity.utc(true).toISOString(), 'pgws')
    if (acceptTerms === false) return enqueueSnackbar('Please accept Term and Conditions', { variant: "error" })


    const data = {
      "accountId": inputFields.paymentGateway.selected,
      "validity": validity.toISOString(),
      "productId": inputFields.service.selected,
      "paymentType": "REFUND_IBAN",
      "amount": parseInt(inputFields.amount.value.replaceAll(',', '')),
      "currencyId": getOffice.office.currency.id,
      "autoAmount": false,
      "autoBooking": false,
      "reference": inputFields.pnr.value,
      "primaryContact": inputFields.primaryContact.value,
      "mobile": inputFields.phone.value,
      "email": inputFields.email.value,
      "iban": inputFields.iban.value,
      "additionalDate": additionalDate.toISOString(),
      "additionalParam": selectedFlightType,
      "comments": inputFields.comment.value
    }

    data.reference = data.reference.toUpperCase()
    // const hasError = createTransactionValidation(data)
    // if(hasError) {
    //     return 
    // }

    const res = await ajax({
      method: 'POST',
      hasToken: true,
      url: utils.urls.createTransaction,
      data,
      snackbar: enqueueSnackbar
    })

    if (!res) return

    console.log(res, 'created')
    navigate('/agent/payments/iban-inquiry', { replace: true, state: res.data.id })
  }

  const updateTransaction = async () => {

    const data = {
      "accountId": inputFields.paymentGateway.selected,
      "validity": validity.toISOString(),
      "productId": inputFields.service.selected,
      "amount": parseInt(inputFields.amount.value.replaceAll(',', '')),
      "currencyId": getOffice.office.currency.id,
      "autoAmount": false,
      "autoBooking": false,
      "reference": inputFields.pnr.value,
      "primaryContact": inputFields.primaryContact.value,
      "mobile": inputFields.phone.value,
      "email": inputFields.email.value,
      "iban": inputFields.iban.value,
      "additionalDate": additionalDate.toISOString(),
      "additionalParam": selectedFlightType,
      "comments": inputFields.comment.value
    }
    data.reference = data.reference.toUpperCase()



    const res = await ajax({
      method: 'PUT',
      url: utils.urls.updateLink(id),
      hasToken: true,
      snackbar: enqueueSnackbar,
      data
    })

    if (!res) return

    navigate('/agent/payments', { replace: true })
  }

  const fillData = (detail) => {
    console.log('to k nmizani', detail)
    setValidity(dayjs(detail.validity))
    setAdditionalDate(dayjs(detail?.additionalDate))
    // setAutoBooking(detail.autoBooking)
    setInputFields({
      ...inputFields,
      amount: {
        ...inputFields.amount,
        value: detail.amount?.toLocaleString()
      },
      primaryContact: {
        ...inputFields.primaryContact,
        value: detail.primaryContact
      },
      phone: {
        ...inputFields.phone,
        value: detail.mobile
      },
      email: {
        ...inputFields.email,
        value: (detail.email ? detail.email : '')
      },
      pnr: {
        ...inputFields.pnr,
        value: detail.reference
      },
      service: {
        ...inputFields.service,
        selected: detail.product.id,
        value: detail.product.name
      },
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: detail.account.id,
        value: detail.account.name
      },
      iban: {
        ...inputFields.iban,
        value: detail.iban
      }
    })
  }


  const getTransactionDetail = async () => {

    const res = await ajax({
      method: 'GET',
      url: utils.urls.linkDetail(id),
      hasToken: true,
      snackbar: enqueueSnackbar
    })

    if (!res) return

    console.log(res.data, ' inja request mizane')
    const detail = res.data
    fillData(detail)

    console.log(detail, 'inja por mishe')
  }

  useEffect(() => {
    console.log(id, ' in detail ee')
    if (id) {
      getTransactionDetail()
    } else {

      getProductsAndAccounts()
    }


  }, [id])


  return (
    <>
      <div className="form-container__header"> Complete link information</div>

      <div className="value">
        <label>Amount *</label>
        <div className="value-container">
          <div className="value-input">
            <Input inputField={inputFields.amount} onChange={handleChange} />
          </div>
          <div className="value-currency">{getOffice.office.currency.code}</div>
        </div>
      </div>
      <div className="value">
        <label>IBAN *</label>
        <div className="value-container">
          <div className="value-input" >
            <Input inputField={inputFields.iban} onChange={handleChange} />
          </div>
        </div>
      </div>

      <div className="form-container__inputs">
        <div className="row">
          <div className="officeId">
            <label>Contact person</label>
            <Input
              className="extra"
              inputField={inputFields.primaryContact}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Mobile*</label>
            <Input
              className="extra"
              inputField={inputFields.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Email*</label>
            <Input
              className="extra"
              inputField={inputFields.email}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Reference*</label>
            <Input
              className="extra"
              inputField={inputFields.pnr}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Product</label>
            <Input
              className="extra"
              inputField={inputFields.service}
              onChange={handleChange}
              onClickDropdownItem={handleSelectDropDown}
            />
          </div>
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="Homares Refund Date"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={additionalDate}
                onChange={handleDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>

        </div>

        <div className="row">
          <div className="officeId">
            <label>Payment Gateway</label>
            <Input
              className="extra"
              inputField={inputFields.paymentGateway}
              onChange={handleChange}
              onClickDropdownItem={handlePGWDropDown}
            />
          </div>
          <div className="officeCode">
            <label>Flight type</label>
            <div style={{ 'marginTop': '10px' }}>
              <label>DOM</label>
              <Radio

                checked={selectedFlightType === 'DOM'}
                onChange={handleChangeFlightType}
                value="DOM"
                name="radio-buttons"
                inputProps={{ 'aria-label': 'DOM' }}
              />
              <label>INT</label>
              <Radio
                checked={selectedFlightType === 'INT'}
                onChange={handleChangeFlightType}
                value="INT"
                name="radio-buttons"
                inputProps={{ 'aria-label': 'INT' }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="textarea">
            <label>Comment</label>
            <Input
              className="extra"
              inputField={inputFields.comment}
              onChange={handleChange}
            />
          </div>

        </div>
      </div>
      {
        !id &&
        <>

          <div style={{ 'marginTop': '50px', 'display': 'flex', 'justifyContent': 'flex-end', 'gap': '5px' }}>
            <input type='checkbox' onChange={handleAcceptTerms} value={acceptTerms}></input>
            <p>Agree to   </p><p style={{ 'color': 'blue', 'textDecoration': 'underline' }} onClick={() => openModal()}>  Terms And Conditiond</p>
          </div>
          <div className="btn-container">
            <button onClick={() => { navigate('/agent/payments', { replace: true }) }} className="payment-btn-back">Back</button>
            <button onClick={createTransaction} className="payment-btn" id="btn1">Create</button>
          </div>
        </>
      }

      {
        id &&
        <div className="btn-container">
          <button onClick={() => { navigate('/agent/payments', { replace: true }) }} className="payment-btn-back">Back</button>
          <button onClick={updateTransaction} className="payment-btn">Save</button>

        </div>
      }
      <TermModal ref={termModal} />
    </>
  )
}

export default RefundForm
